
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/v20-dev/approve_token",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/v20-dev/approve_token/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/v20-dev/approve_token"])
      });
    }
  